import React from "react";

const PartPayment = () => {
  return (
    <section className="container text-center my-5">
      <h3 className="fw-bold mb-3">
        For Part Payment
      </h3>

      <div>
        <a
          href="https://u.payu.in/SJD8xxWY6TlW"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            width: "135px",
            background: "linear-gradient(135deg, #053025, #4cb848)", // gradient same
            textAlign: "center",
            fontWeight: "800",   // senior wala
            padding: "11px 0px",
            color: "white",
            fontSize: "12px",    // senior wala
            display: "inline-block",
            textDecoration: "none",
            borderRadius: "3.229px",
          }}
        >
          Pay Now
        </a>
      </div>
    </section>
  );
};

export default PartPayment;
